var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "table-responsive" }, [
    _c("table", [
      _c("thead", [
        _c("tr", [
          _c("th"),
          _vm._v(" "),
          _c("th", [_vm._v("Item")]),
          _vm._v(" "),
          _c("th", [_vm._v("Cantidad")]),
          _vm._v(" "),
          _c("th", [
            _c(
              "button",
              {
                staticClass: "btn-success",
                attrs: { type: "button" },
                on: { click: _vm.agregar }
              },
              [_c("i", { staticClass: "fa fa-plus" })]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "tbody",
        _vm._l(_vm.modelValue, function(item, index) {
          return _c("tr-egreso-bodega", {
            key: _vm.moment(new Date()).format("YYYYMMDDHHmmss") + index,
            tag: "tr",
            attrs: { index: index },
            on: { eliminar: _vm.eliminar },
            model: {
              value: _vm.modelValue[index],
              callback: function($$v) {
                _vm.$set(_vm.modelValue, index, $$v)
              },
              expression: "modelValue[index]"
            }
          })
        }),
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f3e771c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f3e771c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/TablaEgresoBodega.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-2f3e771c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/inventario/TablaEgresoBodega.vue
// module chunks = 0